import { render, staticRenderFns } from "./UsersVersion.vue?vue&type=template&id=456dcfa2&scoped=true"
import script from "./UsersVersion.vue?vue&type=script&lang=js"
export * from "./UsersVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dcfa2",
  null
  
)

export default component.exports